export const ROUTE_CART_INDEX = '/carrinho'

export default {
  cart: ROUTE_CART_INDEX,
}
